import orderSuccess from "containers/order-success";
import {
  API_ERROR_OPEN,
  API_ERROR_PUSH,
  API_ERROR_UPDATE,
  COMBO_CUSTOM_PRICE,
  COMBO_CUSTOM_PRICE_ONLY_SELECT,
  FUNC_SHOW_PAYMENT_QR_ORDER,
  SET_IS_PAY_ADVANCE,
  SET_PENDING_SUBMIT_PAYLOAD,
  SET_PREPAID_ID,
  FW_SUBMIT_FOR_LESS_THAN_THREE_GUEST,
  FW_SUBMIT_FOR_ROUND_DEFAULT,
  HIDDEN_FREE_SOUP,
  HOTPOT_SELECTING,
  NO_INTERNET,
  ONBOARDING_URL,
  SET_ALC_ITEM,
  SET_BF_EXTRA_COUNT_CHILDREN,
  SET_BUFFET_ITEM,
  SET_BUFFET_TICKET,
  SET_CART_DETAIL,
  SET_CURRENT_LANGUAGE,
  SET_DATA_INFO_USER_TGS,
  SET_DATA_INFO_VAT,
  SET_DATA_USER_SESSION,
  SET_DRAFT_HOME_BRAND,
  SET_FEEDBACK_CONFIG,
  SET_FEEDBACK_CONFIG_CONTENT,
  SET_HOME_BRAND,
  SET_HOTPOT_GUIDELINE_DISPLAYED,
  SET_IS_BF_MENU,
  SET_IS_BF_PENDING_DISH,
  SET_IS_CHECK_COMMENT,
  SET_IS_HIDE_PRICE,
  SET_IS_NEED_REFRESH_MENU,
  SET_IS_POINT_ONEMOUNT,
  SET_IS_REFRESH_PAGE,
  SET_IS_SHOW_MESSAGE,
  SET_KALO_GROUP_PENDING,
  SET_LIST_SESSION,
  SET_MENU,
  SET_ORDER_OVERVIEW,
  SET_OUT_OF_DISH_VERSION,
  SET_PARAMS_HOTPOT_BF,
  SET_PAYMENT_PARTNER,
  SET_POSITION_SCROLL,
  SET_SHOW_TAB_ON_CART,
  SET_SIZE_IN_HOME,
  SET_TAB_ACTIVE,
  SET_TIP_TOP_DOWN,
  SET_VERSION_MENU,
  SET_SERVING_CONTEXT,
  SET_VERTICAL_LAYOUT_QR_ORDER,
  SHOW_TOTAL_PRICE_APPLY_DISCOUNT,
  TIP_SUGGEST_BY_PERCENT,
  SET_COMENUGROUP_HOTPOT,
  SET_ORDER_SUCCESS,
  SET_MAXIMUM_DISHES_BEING_SERVED,
  FUNC_SHOW_TIPPING,
  TIP_SUGGEST_BY_PERCENT_HIGH,
  TIP_TOP_DOWN_HIGH,
  USER_DEFAULT_OPEN_TABLE_QR_STATIC,
  VISIBLE_MENU_BY_WEEKDAYS,
  VISIBLE_MENU_BY_SPECIAL_DAYS,
  SET_TAKE_TAX,
  SET_INFO_TGS_V3,
  ALLOW_EXPEDITE_FULL_ORDER,
  TABLE_CODE,
  SET_PARAM_CONFIG,
  BF_PRICE_SHIFT,
} from "../types";

const INITIAL_STATE = {
  cartDetail: [],
  cartDetailTotal: null,
  homeBrand: null,
  orderSuccess: null,
  menu: null,
  version: 0,
  servingContext: null,
  isNeedRefreshMenu: false,
  isRefreshPage: false,
  isFirstShowModalFoodwasted: true,
  isPendingDish: false,
  kaloGroupPending: [],
  percentSubmitForRound: 0,
  isShowMessage: false,
  dataOverview: null,
  isLanguageEnglish: false,
  versionOutofDish: 0,
  buffetItem: [],
  alcItem: [],
  activeTab: "buffet-product",
  position: 0,
  isHidePrice: true,
  isFoodWasteAllAccept: false,
  type: 2,
  holdPerCell: [],
  IsMwActiveFw: false,
  fwWeightThreshold: "100",
  fwSubmitTimeThreshold: "2",
  listSession: [],
  fwThresHoldBetweenLandmarks: 3,
  bfExtraTicket: [],
  ratingGuid: "",
  tipTopDown: [],
  isBfExtraCountChild: false,
  submitForRoundDefault: [],
  submitForLessThanThreeGuest: [],
  isShowTabOnCart: true,
  infoVat: null,
  infoUserTgs: "",
  userSession: null,
  paymentPartnerSelected: "",
  isShowFuncPayment: false,
  isPayAdvance: false,
  pendingSubmitPayload: null,
  prepaidId: "",
  draftHomeBrand: "",
  isPoint: false,
  feedbackConfigDefault: [],
  isShowContent: true,
  isSizeInHome: false,
  isVerticalLayoutQrOrder: false,
  isShowTotalPriceDiscount: false,
  tipPercent: [],
  isCustomPrice: false,
  isCustomPriceOnlySelect: false,
  apiErrors: {
    isOpenModal: false,
    apis: [],
  },
  isOpenModalNoInternet: false,
  paramsHotpotBF: {},
  isMenuBF: false,
  isHotpotGuidelineDisplayed: false,
  orderOverview: {},
  hotpotSelecting: {},
  isHiddenFreeSoup: false,
  onboardingUrl: "",
  coMenuGroupHotpot: [],
  maximumDishesBeingServed: 0,
  isShowTipping: false,
  tipPercentHigh: "",
  tipTopDownHigh: "",
  isAutoCreateOrder: false,
  visibleMenuByWeekday: "",
  visibleMenuBySpecialDay: "",
  takeTax: false,
  infoTgsV3: "",
  isShowBtnDish: false,
  tableCode: "",
  paramConfig: [],
  bfPriceShift: "",
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_HOME_BRAND:
      return {
        ...state,
        homeBrand: action.payload,
      };
    case SET_CART_DETAIL:
      let cartDetailTotal = {
        totalQuantity: 0,
        totalPrice: 0,
      };
      let tempTotalPrice = 0;
      action.payload.cartDetail?.forEach((product, index) => {
        let currentQuantity = 0;
        if (product?.["is-hotpot"]) {
          currentQuantity = product?.qtyRealOrder;
        } else {
          currentQuantity = product?.quantity;
        }
        cartDetailTotal.totalQuantity =
          cartDetailTotal?.totalQuantity + currentQuantity;

        product?.["lst-topping"]?.forEach((topping, i) => {
          if (topping.isSelected) {
            tempTotalPrice += currentQuantity * topping.price;
          }
        });
        let totalPrice = 0;
        if (product?.["productType"] === "combo") {
          if (product?.["is-hotpot"]) {
            product?.listItemComboSelect?.forEach((p, i) => {
              if (p?.isNoFree && p?.["extra-item"]) {
                totalPrice =
                  totalPrice + p.qtyRealOrder * p?.["extra-item"]?.price;
              } else {
                totalPrice =
                  totalPrice +
                  p.qtyRealOrder * p?.["co-menu-item-details"]?.[0]?.price;
              }
            });
          } else {
            if (!state.isCustomPrice) {
              if (product?.priceFix) {
                totalPrice = currentQuantity * product?.price;
              } else {
                product?.["lst-group"]?.forEach((p, i) => {
                  let isSelectedSize = false;
                  p["lst-item-size"].map((gSize) => {
                    if (gSize?.isSelected) {
                      isSelectedSize = true;
                      totalPrice = totalPrice + p.quantity * gSize.price;
                    }
                  });
                  if (!isSelectedSize) {
                    if (p.quantity > 0) {
                      totalPrice = totalPrice + p.quantity * p.price;
                    }
                  }
                  p["lst-topping"].map((gTopping) => {
                    if (gTopping.isSelected) {
                      totalPrice = totalPrice + p.quantity * gTopping.price;
                    }
                  });
                });
              }
            } else {
              totalPrice = currentQuantity * product?.price;
              product?.["lst-group"]?.forEach((p, i) => {
                let isSelectedSize = false;
                p["lst-item-size"].map((gSize) => {
                  if (gSize?.isSelected) {
                    isSelectedSize = true;
                    totalPrice =
                      totalPrice + p.quantity * product?.quantity * gSize.price;
                  }
                });
                if (!isSelectedSize) {
                  if (p.quantity > 0) {
                    totalPrice =
                      totalPrice + p.quantity * product?.quantity * p.price;
                  }
                }
                p["lst-topping"].map((gTopping) => {
                  if (gTopping.isSelected) {
                    totalPrice =
                      totalPrice +
                      p.quantity * product?.quantity * gTopping.price;
                  }
                });
              });
              product?.itemDefault?.forEach((p, i) => {
                let isSelectedSize = false;
                p["lst-item-size"].map((gSize) => {
                  if (gSize?.isSelected) {
                    isSelectedSize = true;
                    totalPrice =
                      totalPrice + p.quantity * product?.quantity * gSize.price;
                  }
                });
                if (!isSelectedSize) {
                  if (p?.quantity > 0) {
                    totalPrice =
                      totalPrice + p?.quantity * product?.quantity * p?.price;
                  }
                }
                p["lst-topping"].map((gTopping) => {
                  if (gTopping.isSelected) {
                    totalPrice =
                      totalPrice +
                      p.quantity * product?.quantity * gTopping.price;
                  }
                });
              });
            }
          }
        } else {
          totalPrice =
            currentQuantity * product?.["co-menu-item-details"]?.[0]?.price;
        }
        tempTotalPrice += totalPrice;
      });
      cartDetailTotal.totalPrice = tempTotalPrice;

      return {
        ...state,
        cartDetail: action.payload.cartDetail,
        cartDetailTotal: cartDetailTotal,
      };
    case SET_MENU:
      return {
        ...state,
        menu: action.payload,
      };
    case SET_VERSION_MENU:
      return {
        ...state,
        version: action.payload,
      };
    case SET_SERVING_CONTEXT:
      return {
        ...state,
        servingContext: action.payload,
      };
    case SET_INFO_TGS_V3:
      return {
        ...state,
        infoTgsV3: action.payload,
      };
    case SET_IS_NEED_REFRESH_MENU:
      return {
        ...state,
        isNeedRefreshMenu: action.payload,
      };
    case SET_IS_REFRESH_PAGE:
      return {
        ...state,
        isRefreshPage: action.payload,
      };
    case SET_IS_BF_PENDING_DISH:
      return {
        ...state,
        isPendingDish: action.payload,
      };
    case SET_KALO_GROUP_PENDING:
      return {
        ...state,
        kaloGroupPending: action.payload,
      };
    case SET_IS_SHOW_MESSAGE:
      return {
        ...state,
        isShowMessage: action.payload,
      };
    case SET_CURRENT_LANGUAGE:
      return {
        ...state,
        isLanguageEnglish: action.payload,
      };
    case SET_OUT_OF_DISH_VERSION:
      return {
        ...state,
        versionOutofDish: action.payload,
      };
    case SET_ALC_ITEM:
      return {
        ...state,
        alcItem: action.payload,
      };
    case SET_BUFFET_ITEM:
      return {
        ...state,
        buffetItem: action.payload,
      };
    case SET_TAB_ACTIVE:
      return {
        ...state,
        activeTab: action.payload,
      };
    case SET_POSITION_SCROLL:
      return {
        ...state,
        position: action.payload,
      };
    case SET_IS_HIDE_PRICE:
      return {
        ...state,
        isHidePrice: action.payload,
      };
    case SET_LIST_SESSION:
      return {
        ...state,
        listSession: [...action.payload],
      };
    case SET_BUFFET_TICKET:
      return {
        ...state,
        bfExtraTicket: action.payload,
      };
    case SET_IS_CHECK_COMMENT:
      return {
        ...state,
        ratingGuid: action.payload,
      };
    case SET_TIP_TOP_DOWN:
      return {
        ...state,
        tipTopDown: action.payload,
      };
    case SET_BF_EXTRA_COUNT_CHILDREN:
      return {
        ...state,
        isBfExtraCountChild: action.payload,
      };
    case FW_SUBMIT_FOR_ROUND_DEFAULT:
      return {
        ...state,
        submitForRoundDefault: action.payload,
      };
    case FW_SUBMIT_FOR_LESS_THAN_THREE_GUEST:
      return {
        ...state,
        submitForLessThanThreeGuest: action.payload,
      };
    case SET_SHOW_TAB_ON_CART:
      return {
        ...state,
        isShowTabOnCart: action.payload,
      };
    case SET_DATA_INFO_VAT:
      return {
        ...state,
        infoVat: action.payload,
      };
    case SET_TAKE_TAX:
      return {
        ...state,
        takeTax: action.payload,
      };
    case SET_DATA_INFO_USER_TGS:
      return {
        ...state,
        infoUserTgs: action.payload,
      };
    case SET_DATA_USER_SESSION:
      return {
        ...state,
        userSession: action.payload,
      };
    case SET_PAYMENT_PARTNER:
      return {
        ...state,
        paymentPartnerSelected: action.payload,
      };
    case FUNC_SHOW_PAYMENT_QR_ORDER:
      return {
        ...state,
        isShowFuncPayment: action.payload,
      };
    case SET_IS_PAY_ADVANCE:
      return {
        ...state,
        isPayAdvance: action.payload,
      };
    case SET_PENDING_SUBMIT_PAYLOAD:
      return {
        ...state,
        pendingSubmitPayload: action.payload,
      };
    case SET_PREPAID_ID:
      return {
        ...state,
        prepaidId: action.payload,
      };
    case SET_DRAFT_HOME_BRAND:
      return {
        ...state,
        draftHomeBrand: action.payload,
      };
    case SET_IS_POINT_ONEMOUNT:
      return {
        ...state,
        isPoint: action.payload,
      };
    case SET_FEEDBACK_CONFIG:
      return {
        ...state,
        feedbackConfigDefault: action.payload,
      };
    case SET_FEEDBACK_CONFIG_CONTENT:
      return {
        ...state,
        isShowContent: action.payload,
      };
    case SET_SIZE_IN_HOME:
      return {
        ...state,
        isSizeInHome: action.payload,
      };
    case SET_VERTICAL_LAYOUT_QR_ORDER:
      return {
        ...state,
        isVerticalLayoutQrOrder: action.payload,
      };
    case SHOW_TOTAL_PRICE_APPLY_DISCOUNT:
      return {
        ...state,
        isShowTotalPriceDiscount: action.payload,
      };
    case TIP_SUGGEST_BY_PERCENT:
      return {
        ...state,
        tipPercent: action.payload,
      };
    case COMBO_CUSTOM_PRICE:
      return {
        ...state,
        isCustomPrice: action.payload,
      };
    case COMBO_CUSTOM_PRICE_ONLY_SELECT:
      return {
        ...state,
        isCustomPriceOnlySelect: action.payload,
      };
    case API_ERROR_UPDATE:
      return {
        ...state,
        apiErrors: { ...state.apiErrors, apis: action.payload },
      };
    case API_ERROR_PUSH:
      return {
        ...state,
        apiErrors: {
          ...state.apiErrors,
          apis: [...(state?.apiErrors?.apis || []), ...(action.payload || [])],
        },
      };
    case API_ERROR_OPEN:
      return {
        ...state,
        apiErrors: { ...state.apiErrors, isOpen: action.payload },
      };
    case NO_INTERNET:
      return {
        ...state,
        isOpenModalNoInternet: action.payload,
      };
    case SET_PARAMS_HOTPOT_BF:
      return {
        ...state,
        paramsHotpotBF: action.payload,
      };
    case SET_IS_BF_MENU:
      return {
        ...state,
        isMenuBF: action.payload,
      };
    case SET_HOTPOT_GUIDELINE_DISPLAYED:
      return {
        ...state,
        isHotpotGuidelineDisplayed: action.payload,
      };
    case SET_ORDER_OVERVIEW:
      return {
        ...state,
        orderOverview: action.payload,
      };
    case HOTPOT_SELECTING:
      return {
        ...state,
        hotpotSelecting: action.payload,
      };
    case HIDDEN_FREE_SOUP:
      return {
        ...state,
        isHiddenFreeSoup: action.payload,
      };
    case ONBOARDING_URL:
      return {
        ...state,
        onboardingUrl: action.payload,
      };
    case SET_COMENUGROUP_HOTPOT:
      return {
        ...state,
        coMenuGroupHotpot: action.payload,
      };
    case SET_ORDER_SUCCESS:
      return {
        ...state,
        orderSuccess: action.payload,
      };
    case SET_MAXIMUM_DISHES_BEING_SERVED:
      return {
        ...state,
        maximumDishesBeingServed: action.payload,
      };
    case FUNC_SHOW_TIPPING:
      return {
        ...state,
        isShowTipping: action.payload,
      };
    case TIP_SUGGEST_BY_PERCENT_HIGH:
      return {
        ...state,
        tipPercentHigh: action.payload,
      };
    case TIP_TOP_DOWN_HIGH:
      return {
        ...state,
        tipTopDownHigh: action.payload,
      };
    case USER_DEFAULT_OPEN_TABLE_QR_STATIC:
      return {
        ...state,
        isAutoCreateOrder: action.payload,
      };
    case VISIBLE_MENU_BY_WEEKDAYS:
      return {
        ...state,
        visibleMenuByWeekday: action.payload,
      };
    case VISIBLE_MENU_BY_SPECIAL_DAYS:
      return {
        ...state,
        visibleMenuBySpecialDay: action.payload,
      };
    case ALLOW_EXPEDITE_FULL_ORDER:
      return {
        ...state,
        isShowBtnDish: action.payload,
      };
    case TABLE_CODE:
      return {
        ...state,
        tableCode: action.payload,
      };
    case SET_PARAM_CONFIG:
      return {
        ...state,
        paramConfig: action.payload || [],
      };
    case BF_PRICE_SHIFT:
      return {
        ...state,
        bfPriceShift: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
